import Reveal from '@/components/base/Reveal';
import { quickFacts } from '@/mocks/content';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function QuickFacts() {
  return (
    <section id="overview" className="scroll-mt-16 bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="Overview"
            title="作品速览：一眼看清是什么"
            desc="在深入阅读之前，先用几个关键信息勾勒出《漂亮的保姆》的整体轮廓——它讲述的是什么题材、以什么形式呈现、又适合怎样的读者。"
          />
        </Reveal>

        <Reveal delay={80}>
          <dl className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
            {quickFacts.map((fact) => (
              <div
                key={fact.label}
                className="rounded-lg bg-background-50 border border-background-200 p-4 md:p-5 flex flex-col gap-3"
              >
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 text-lg">
                  <i className={fact.icon} />
                </span>
                <dt className="text-xs font-label tracking-wide text-foreground-500">{fact.label}</dt>
                <dd className="font-heading text-base md:text-lg font-semibold text-foreground-900 leading-snug">
                  {fact.value}
                </dd>
              </div>
            ))}
          </dl>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-6 rounded-lg bg-background-50 border border-background-200 p-5 md:p-7 flex flex-col md:flex-row md:items-center gap-4">
            <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 text-xl shrink-0">
              <i className="ri-compasses-2-line" />
            </span>
            <p className="text-sm md:text-base leading-relaxed text-foreground-700">
              简单来说，这是一部以家庭日常为背景的都市情感作品，既有文字的细腻铺陈，也有漫画的画面表达。
              下面的分区会从故事背景、人物类型、资源格式到阅读脉络逐层展开，你可按需跳转查看。
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}